
      var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgYellowWarning = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: 80,
  width: 80,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 41"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20 39.693C9.48 39.693.917 31.13.917 20.609.917 10.088 9.479 1.526 20 1.526c10.522 0 19.084 8.562 19.084 19.083 0 10.522-8.562 19.084-19.084 19.084z",
  fill: "#FFDE31",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 1.833
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.02 11.36 20 24.58l.98-13.222a.982.982 0 1 0-1.96 0z",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 2.083,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 29.984,
  r: 1.875,
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg height=\"80\" width=\"80\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 41\">     <path d=\"M20 39.693C9.48 39.693.917 31.13.917 20.609.917 10.088 9.479 1.526 20 1.526c10.522 0 19.084 8.562 19.084 19.083 0 10.522-8.562 19.084-19.084 19.084z\" fill=\"#FFDE31\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"1.833\"></path>     <path d=\"M19.02 11.36 20 24.58l.98-13.222a.982.982 0 1 0-1.96 0z\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"2.083\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path>     <circle cx=\"20\" cy=\"29.984\" r=\"1.875\" fill=\"var(--theme-primary, #810ea9)\"></circle> </svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/yellowWarning.1dcd8fff096868de17ff71553d61bb30.svg"),
        {
          React: SvgYellowWarning,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      